import renderIcon from 'helpers/renderIcon';
import { ICustomer } from 'models/shop/customer';
import { IShopCard } from 'models/shop/shopcard';
import { IShopProfile } from 'models/shop/shopprofile';
import { IUserCard } from 'models/user/usercard';
import { IUserPreferences } from 'models/user/userpreferences';
import { IUserProfile } from 'models/user/userprofile';
import * as React from 'react';
import { Link } from 'react-router';
import { thumbUrl } from 'helpers/common';

interface IProps {
	backLink?: string | (() => void);
	type?: 'user' | 'shop';
	customTitleElement?: JSX.Element;
	customFigureClass?: string;
}

interface IStaticProps {
	coverImageUrl?: string;
	imageUrl?: string;
	name: string;
	url?: string;
}

interface IItemProps {
	item: IShopCard | IShopProfile | IUserProfile | IUserCard | ICustomer | IUserPreferences;
}

type Props = IProps & (IStaticProps | IItemProps);

const normalizeItem = (item: IItemProps['item'], type: IProps['type']): IStaticProps => {
	if (!item) {
		return { name: '' };
	}
	let name = '';
	let coverImageUrl;
	let imageUrl;
	if ('picture' in item) {
		imageUrl = item.picture;
		if ('coverPicture' in item) {
			coverImageUrl = item.coverPicture;
		}
	} else if ('imageUrl' in item) {
		imageUrl = item.imageUrl;
	} else if ('profilePicture' in item) {
		imageUrl = item.profilePicture;
	}
	if (!name && 'name' in item) {
		name = item.name;
	}
	let url: string;
	if (type === 'shop') {
		if (item.code) {
			url = '/shop/' + item.code;
		}
	} else if (type === 'user') {
		if (item.code) {
			url = '/profile/' + item.code;
		}
	}
	return {
		imageUrl,
		coverImageUrl,
		name,
		url,
	};
};

const PortalTopPart: React.FC<Props> = (props: Props) => {
	const { backLink, customTitleElement, customFigureClass } = props;
	let normalized: IStaticProps;
	if ('item' in props) {
		normalized = normalizeItem(props.item, props.type);
	} else {
		normalized = props;
	}
	const type = props.type || 'user';
	const holderStyles: React.CSSProperties = {};
	if (normalized.coverImageUrl) {
		holderStyles.backgroundImage = 'url("' + thumbUrl(normalized.coverImageUrl, 'banner') + '")';
	}
	const figureStyles: React.CSSProperties = {};
	if (normalized.imageUrl) {
		figureStyles.backgroundImage = 'url("' + thumbUrl(normalized.imageUrl, 'small') + '")';
	}
	let back: JSX.Element;
	if (backLink) {
		if (typeof backLink === 'string') {
			back = (
				<Link to={backLink} className="textBtn">
					{renderIcon('back')}
				</Link>
			);
		} else {
			back = (
				<button className="textBtn pointer" onClick={backLink}>
					{renderIcon('back')}
				</button>
			);
		}
	}
	let titleElement: JSX.Element;
	if (customTitleElement) {
		titleElement = customTitleElement;
	} else {
		titleElement = (
			<>
				<div style={figureStyles} className={`${customFigureClass ? customFigureClass : 'portalTopPartSmall__figure'}`}>
					{normalized.imageUrl ? null : renderIcon(type === 'user' ? 'pfp_default' : 'open_salon')}
				</div>
				<figcaption>{normalized.name}</figcaption>
			</>
		);
	}

	let fullElement: JSX.Element;
	if (normalized.url) {
		fullElement = (
			<Link to={normalized.url}>
				{back}
				{titleElement}
			</Link>
		);
	} else {
		fullElement = (
			<figure>
				{back}
				{titleElement}
			</figure>
		);
	}
	return (
		<header className="portalTopPartSmall" style={holderStyles}>
			{fullElement}
		</header>
	);
};

export { PortalTopPart };
